import AuthManager from "Common/AuthManager";
import ServiceWrapper from "Services/ServiceWrapper";
import AppSettings from "Settings/AppSettings";

const api_base_url = AppSettings.GMS_BACKEND_API_URL;

export const getRecategorizationList = async (sourceCategoryId: string, targetCategoryId: string, productList: string) => {
    try {
        const ret = await ServiceWrapper.doGet(
            `${api_base_url}recategorisation/${sourceCategoryId}/target/${targetCategoryId}?prod_list=${[productList]}`,
            null,
            null,
            AuthManager.getGmsToken()
        );
        if (!ret.errorfound) {
            return ret?.data?.data;
        } else {
            return ret?.data?.message;
        }
    } catch (error) {
        return "could'nt get the list";
    }
};

export const getUniqueAttributeValues = async (attributeId: string, pageNum: number, attr_val_list: string, search?: string) => {
    try {
        const ret = await ServiceWrapper.doPost(
            `${api_base_url}get_attribute_values?page=${pageNum}&limit=10&search=${search}&attr_val_list=${[attr_val_list]}`,
            { attribute_ids: [attributeId] },
            null,
            AuthManager.getGmsToken()
        );

        if (!ret.errorfound) {
            return ret?.data;
        } else {
            return ret?.data?.message;
        }
    } catch (error) {
        return "could'nt get attribute values";
    }
};

export const getCommonAttributeValues = async (targetAttributeId: string, attr_val_list: string) => {
    try {
        const response = await ServiceWrapper.doGet(
            `${api_base_url}recategorisation/common_attribute/target/${targetAttributeId}?attr_val_list=${[attr_val_list]}`,
            null,
            null,
            AuthManager.getGmsToken()
        );

        if (!response.errorfound) {
            return response?.data;
        } else {
            return response?.data?.message;
        }
    } catch (error) {
        return "could'nt get attribute values";
    }
};



export const PostRecategorization = async (payload: TRecategorizePayload) => {
    try {
        const ret = await ServiceWrapper.doPost(
            `${api_base_url}product/recategorise`,
            payload,
            null,
            AuthManager.getGmsToken()
        );

        if (!ret.errorfound) {
            return ret?.data;
        } else {
            return ret?.data?.message;
        }
    } catch (error) {
        return "Recategorization failed";
    }
};